import React from 'react'
import GettingStarted from './Components/GettingStarted'
import Overview from './Overview'
import { useSelector } from 'react-redux';

export default function Dashboard() {
  const { user } = useSelector((state) => state.auth);
    const showGettingStarted = user?.contactLength == 0;
  return (
    showGettingStarted ? <GettingStarted /> :
    <Overview />
  )
}
